module.exports = __webpack_public_path__ + "static/media/TR.4a724c95.svg";